export default {
  title: 'Nigeria',
  version: '1.1.3',
  type: 'FeatureCollection',
  copyright: 'Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth',
  copyrightShort: 'Natural Earth',
  copyrightUrl: 'http://www.naturalearthdata.com',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:EPSG:26392' } },
  'hc-transform': {
    default: {
      crs: '+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs',
      scale: 0.000531855453682,
      jsonres: 15.5,
      jsonmarginX: -999,
      jsonmarginY: 9851.0,
      xoffset: 27017.6170862,
      yoffset: 1093650.26339,
    },
  },
  features: [
    {
      type: 'Feature',
      id: 'NG.RI',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.36,
        'hc-middle-y': 0.55,
        'hc-key': 'ng-ri',
        'hc-a2': 'RI',
        labelrank: '3',
        hasc: 'NG.RI',
        'alt-name': null,
        'woe-id': '2346344',
        subregion: null,
        fips: 'NI50',
        'postal-code': 'RI',
        name: 'Rivers',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '6.81969',
        'woe-name': 'Rivers',
        latitude: '4.9979',
        'woe-label': 'Rivers, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3348, 1269],
              [3469, 1277],
              [3456, 1254],
              [3346, 1233],
              [3262, 1236],
              [3251, 1271],
              [3305, 1289],
              [3348, 1269],
            ],
          ],
          [
            [
              [3171, 1289],
              [3239, 1284],
              [3216, 1222],
              [3101, 1184],
              [3061, 1198],
              [3137, 1297],
              [3171, 1289],
            ],
          ],
          [
            [
              [3166, 1924],
              [3179, 1847],
              [3085, 1703],
              [3097, 1632],
              [3134, 1620],
              [3245, 1636],
              [3328, 1621],
              [3389, 1580],
              [3416, 1532],
              [3423, 1476],
              [3421, 1410],
              [3421, 1383],
              [3350, 1339],
              [3220, 1389],
              [3176, 1358],
              [3235, 1324],
              [3192, 1296],
              [3109, 1393],
              [3099, 1445],
              [3060, 1439],
              [3001, 1527],
              [3025, 1439],
              [3070, 1419],
              [3098, 1293],
              [3038, 1247],
              [2975, 1234],
              [2937, 1364],
              [2956, 1396],
              [2938, 1490],
              [2895, 1459],
              [2925, 1390],
              [2912, 1278],
              [2956, 1199],
              [2907, 1177],
              [2807, 1215],
              [2773, 1308],
              [2794, 1409],
              [2755, 1429],
              [2706, 1597],
              [2675, 1597],
              [2727, 1441],
              [2775, 1384],
              [2748, 1347],
              [2786, 1194],
              [2816, 1165],
              [2728, 1145],
              [2674, 1160],
              [2681, 1376],
              [2615, 1423],
              [2594, 1486],
              [2537, 1522],
              [2433, 1491],
              [2421, 1547],
              [2373, 1583],
              [2374, 1620],
              [2431, 1729],
              [2417, 1808],
              [2470, 1933],
              [2589, 2059],
              [2558, 2099],
              [2473, 2107],
              [2458, 2147],
              [2527, 2217],
              [2577, 2408],
              [2605, 2384],
              [2635, 2381],
              [2595, 2206],
              [2667, 2192],
              [2704, 2152],
              [2684, 2026],
              [2817, 1926],
              [2946, 1916],
              [3166, 1924],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KT',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.34,
        'hc-key': 'ng-kt',
        'hc-a2': 'KT',
        labelrank: '7',
        hasc: 'NG.KT',
        'alt-name': null,
        'woe-id': '2346352',
        subregion: null,
        fips: 'NI24',
        'postal-code': 'KT',
        name: 'Katsina',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.58609',
        'woe-name': 'Katsina',
        latitude: '12.5056',
        'woe-label': 'Katsina, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3022, 9038],
            [3143, 9148],
            [3256, 9135],
            [3317, 9143],
            [3642, 9338],
            [3703, 9354],
            [3930, 9321],
            [4080, 9232],
            [4215, 9107],
            [4337, 9097],
            [4467, 8969],
            [4734, 8896],
            [4678, 8811],
            [4595, 8756],
            [4511, 8748],
            [4396, 8779],
            [4339, 8883],
            [4078, 8883],
            [3982, 8869],
            [3964, 8725],
            [4011, 8696],
            [4082, 8694],
            [4112, 8646],
            [4027, 8633],
            [3976, 8507],
            [3943, 8476],
            [3785, 8417],
            [3716, 8370],
            [3708, 8049],
            [3725, 7927],
            [3762, 7809],
            [3630, 7764],
            [3601, 7730],
            [3580, 7642],
            [3594, 7596],
            [3656, 7543],
            [3624, 7496],
            [3551, 7466],
            [3443, 7540],
            [3377, 7553],
            [3321, 7520],
            [3300, 7458],
            [3175, 7458],
            [3176, 7359],
            [3124, 7320],
            [3048, 7373],
            [2950, 7410],
            [2988, 7473],
            [2962, 7525],
            [2851, 7553],
            [2877, 7698],
            [2846, 7754],
            [2881, 7918],
            [2934, 7942],
            [3019, 7929],
            [3093, 7986],
            [3114, 8031],
            [3169, 8034],
            [3159, 8088],
            [3062, 8165],
            [3102, 8270],
            [3071, 8417],
            [3047, 8465],
            [3033, 8566],
            [3006, 8942],
            [3022, 9038],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.SO',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.27,
        'hc-key': 'ng-so',
        'hc-a2': 'SO',
        labelrank: '7',
        hasc: 'NG.SO',
        'alt-name': null,
        'woe-id': '2346361',
        subregion: null,
        fips: 'NI51',
        'postal-code': 'SO',
        name: 'Sokoto',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.4366',
        'woe-name': 'Sokoto',
        latitude: '13.0603',
        'woe-label': 'Sokoto, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [391, 9265],
            [400, 9504],
            [510, 9522],
            [653, 9654],
            [744, 9701],
            [1058, 9769],
            [1118, 9730],
            [1430, 9744],
            [1521, 9836],
            [1682, 9851],
            [2184, 9645],
            [2282, 9667],
            [2406, 9618],
            [2530, 9498],
            [2675, 9337],
            [2746, 9203],
            [2632, 9129],
            [2544, 9129],
            [2457, 9151],
            [2429, 9182],
            [2335, 9196],
            [2306, 9100],
            [2183, 9101],
            [2116, 9044],
            [2130, 8888],
            [2103, 8838],
            [2038, 8815],
            [1836, 8798],
            [1790, 8763],
            [1708, 8651],
            [1666, 8622],
            [1660, 8562],
            [1680, 8423],
            [1634, 8377],
            [1360, 8368],
            [1228, 8392],
            [1193, 8283],
            [1181, 7855],
            [1048, 7867],
            [875, 7792],
            [804, 7730],
            [735, 7777],
            [744, 7864],
            [785, 7949],
            [817, 8091],
            [816, 8442],
            [849, 8499],
            [914, 8514],
            [975, 8493],
            [1015, 8513],
            [1020, 8582],
            [995, 8730],
            [1017, 8864],
            [968, 8973],
            [1014, 9160],
            [976, 9172],
            [945, 9127],
            [883, 9114],
            [821, 9151],
            [697, 9195],
            [589, 9277],
            [525, 9257],
            [391, 9265],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.ZA',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.58,
        'hc-middle-y': 0.45,
        'hc-key': 'ng-za',
        'hc-a2': 'ZA',
        labelrank: '3',
        hasc: 'NG.ZA',
        'alt-name': null,
        'woe-id': '20070150',
        subregion: null,
        fips: 'NI57',
        'postal-code': 'ZA',
        name: 'Zamfara',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '6.12834',
        'woe-name': 'Zamfara',
        latitude: '12.0084',
        'woe-label': 'Zamfara, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1181, 7855],
            [1193, 8283],
            [1228, 8392],
            [1360, 8368],
            [1634, 8377],
            [1680, 8423],
            [1660, 8562],
            [1666, 8622],
            [1708, 8651],
            [1790, 8763],
            [1836, 8798],
            [2038, 8815],
            [2103, 8838],
            [2130, 8888],
            [2116, 9044],
            [2183, 9101],
            [2306, 9100],
            [2335, 9196],
            [2429, 9182],
            [2457, 9151],
            [2544, 9129],
            [2632, 9129],
            [2746, 9203],
            [2821, 9101],
            [2882, 9049],
            [3022, 9038],
            [3006, 8942],
            [3033, 8566],
            [3047, 8465],
            [3071, 8417],
            [3102, 8270],
            [3062, 8165],
            [3159, 8088],
            [3169, 8034],
            [3114, 8031],
            [3093, 7986],
            [3019, 7929],
            [2934, 7942],
            [2881, 7918],
            [2846, 7754],
            [2877, 7698],
            [2851, 7553],
            [2754, 7469],
            [2708, 7336],
            [2657, 7280],
            [2482, 7230],
            [2364, 7258],
            [2259, 7159],
            [2254, 7123],
            [2199, 7098],
            [2186, 7159],
            [2080, 7326],
            [2073, 7465],
            [2005, 7575],
            [1953, 7617],
            [1981, 7748],
            [1939, 7790],
            [1838, 7813],
            [1672, 7794],
            [1541, 7841],
            [1507, 7885],
            [1396, 7888],
            [1373, 7851],
            [1288, 7830],
            [1181, 7855],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.YO',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.69,
        'hc-middle-y': 0.52,
        'hc-key': 'ng-yo',
        'hc-a2': 'YO',
        labelrank: '3',
        hasc: 'NG.YO',
        'alt-name': null,
        'woe-id': '2346372',
        subregion: null,
        fips: 'NI44',
        'postal-code': 'YO',
        name: 'Yobe',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '11.5881',
        'woe-name': 'Yobe',
        latitude: '12.3156',
        'woe-label': 'Yobe, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5334, 8886],
            [5486, 9068],
            [5551, 9111],
            [5585, 9175],
            [5791, 9287],
            [6249, 9389],
            [6335, 9397],
            [6497, 9379],
            [6933, 9386],
            [7204, 9321],
            [7303, 9282],
            [7488, 9167],
            [7541, 9155],
            [7617, 9177],
            [7729, 9136],
            [7783, 9137],
            [7765, 8960],
            [7782, 8902],
            [7871, 8823],
            [7879, 8767],
            [7819, 8656],
            [7721, 8561],
            [7742, 8425],
            [7705, 8117],
            [7723, 7985],
            [7666, 7842],
            [7757, 7828],
            [7805, 7733],
            [7715, 7619],
            [7636, 7495],
            [7638, 7341],
            [7611, 7278],
            [7555, 7235],
            [7343, 7158],
            [7293, 7101],
            [7279, 6920],
            [7195, 6860],
            [7098, 6862],
            [7083, 6954],
            [7092, 7164],
            [7067, 7219],
            [6877, 7424],
            [6819, 7468],
            [6694, 7527],
            [6570, 7493],
            [6502, 7531],
            [6532, 7672],
            [6526, 7749],
            [6416, 8014],
            [6387, 8160],
            [6380, 8263],
            [6343, 8327],
            [6310, 8502],
            [6197, 8592],
            [6160, 8780],
            [6107, 8857],
            [5982, 8880],
            [5884, 8868],
            [5851, 8982],
            [5791, 9029],
            [5623, 8972],
            [5545, 8934],
            [5521, 8886],
            [5443, 8852],
            [5334, 8886],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KE',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.26,
        'hc-middle-y': 0.35,
        'hc-key': 'ng-ke',
        'hc-a2': 'KE',
        labelrank: '3',
        hasc: 'NG.KE',
        'alt-name': null,
        'woe-id': '2346368',
        subregion: null,
        fips: 'NI40',
        'postal-code': 'KE',
        name: 'Kebbi',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '4.06548',
        'woe-name': 'Kebbi',
        latitude: '11.7712',
        'woe-label': 'Kebbi, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1181, 7855],
            [1288, 7830],
            [1373, 7851],
            [1396, 7888],
            [1507, 7885],
            [1541, 7841],
            [1672, 7794],
            [1838, 7813],
            [1939, 7790],
            [1981, 7748],
            [1953, 7617],
            [2005, 7575],
            [2073, 7465],
            [2080, 7326],
            [2020, 7342],
            [1951, 7274],
            [1889, 7264],
            [1732, 7199],
            [1582, 7190],
            [1547, 7230],
            [1552, 7336],
            [1478, 7444],
            [1466, 7512],
            [1413, 7545],
            [1348, 7548],
            [1081, 7497],
            [956, 7443],
            [941, 7386],
            [1062, 7314],
            [1158, 7295],
            [1202, 7263],
            [1222, 7163],
            [1178, 7109],
            [1234, 7002],
            [1084, 6937],
            [993, 6937],
            [977, 6876],
            [981, 6745],
            [1050, 6627],
            [1027, 6567],
            [970, 6539],
            [832, 6507],
            [810, 6415],
            [727, 6439],
            [748, 6572],
            [705, 6612],
            [695, 6746],
            [730, 6804],
            [836, 6862],
            [868, 6913],
            [901, 7149],
            [843, 7167],
            [734, 7240],
            [643, 7266],
            [549, 7253],
            [255, 7256],
            [75, 7356],
            [-15, 7360],
            [-53, 7381],
            [-211, 7612],
            [-225, 7658],
            [-189, 7762],
            [-124, 7867],
            [-40, 7945],
            [-90, 8027],
            [-94, 8079],
            [-48, 8153],
            [-73, 8252],
            [-45, 8411],
            [-46, 8649],
            [153, 8792],
            [212, 8847],
            [359, 9069],
            [391, 9265],
            [525, 9257],
            [589, 9277],
            [697, 9195],
            [821, 9151],
            [883, 9114],
            [945, 9127],
            [976, 9172],
            [1014, 9160],
            [968, 8973],
            [1017, 8864],
            [995, 8730],
            [1020, 8582],
            [1015, 8513],
            [975, 8493],
            [914, 8514],
            [849, 8499],
            [816, 8442],
            [817, 8091],
            [785, 7949],
            [744, 7864],
            [735, 7777],
            [804, 7730],
            [875, 7792],
            [1048, 7867],
            [1181, 7855],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.AD',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.44,
        'hc-middle-y': 0.38,
        'hc-key': 'ng-ad',
        'hc-a2': 'AD',
        labelrank: '3',
        hasc: 'NG.AD',
        'alt-name': null,
        'woe-id': '2346363',
        subregion: null,
        fips: 'NI35',
        'postal-code': 'AD',
        name: 'Adamawa',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '12.5768',
        'woe-name': 'Adamawa',
        latitude: '9.479060000000001',
        'woe-label': 'Adamawa, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [9043, 7204],
            [8881, 6960],
            [8824, 6792],
            [8769, 6477],
            [8702, 6428],
            [8601, 6407],
            [8601, 6310],
            [8572, 6215],
            [8618, 6153],
            [8585, 5980],
            [8560, 5915],
            [8368, 5851],
            [8259, 5765],
            [8294, 5692],
            [8285, 5623],
            [8226, 5503],
            [8233, 5433],
            [8214, 5261],
            [8185, 5194],
            [8137, 5191],
            [8084, 5102],
            [7991, 5052],
            [7922, 5067],
            [7819, 5054],
            [7852, 4951],
            [7797, 4892],
            [7713, 4878],
            [7692, 4848],
            [7703, 4694],
            [7659, 4603],
            [7669, 4473],
            [7541, 4297],
            [7500, 4198],
            [7515, 4126],
            [7405, 3994],
            [7370, 4089],
            [7357, 4211],
            [7313, 4316],
            [7201, 4425],
            [7140, 4426],
            [7078, 4353],
            [7049, 4355],
            [6987, 4446],
            [6946, 4543],
            [6955, 4571],
            [7063, 4683],
            [7296, 4966],
            [7356, 5017],
            [7366, 5144],
            [7455, 5333],
            [7449, 5396],
            [7353, 5469],
            [7321, 5522],
            [7325, 5586],
            [7267, 5706],
            [7214, 5753],
            [7131, 5787],
            [7046, 5943],
            [7129, 5958],
            [7205, 5992],
            [7372, 6094],
            [7419, 6160],
            [7422, 6360],
            [7568, 6354],
            [7682, 6436],
            [7774, 6559],
            [7825, 6603],
            [7964, 6627],
            [8029, 6657],
            [8070, 6718],
            [8126, 6737],
            [8226, 6844],
            [8300, 6862],
            [8440, 6827],
            [8544, 6750],
            [8606, 6737],
            [8651, 6763],
            [8682, 6885],
            [8730, 7009],
            [8746, 7188],
            [8859, 7168],
            [9043, 7204],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.BO',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.43,
        'hc-key': 'ng-bo',
        'hc-a2': 'BO',
        labelrank: '3',
        hasc: 'NG.BO',
        'alt-name': null,
        'woe-id': '2346355',
        subregion: null,
        fips: 'NI27',
        'postal-code': 'BO',
        name: 'Borno',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '13.1533',
        'woe-name': 'Borno',
        latitude: '12.0019',
        'woe-label': 'Borno, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [9043, 7204],
            [8859, 7168],
            [8746, 7188],
            [8730, 7009],
            [8682, 6885],
            [8651, 6763],
            [8606, 6737],
            [8544, 6750],
            [8440, 6827],
            [8300, 6862],
            [8226, 6844],
            [8126, 6737],
            [8070, 6718],
            [8029, 6657],
            [7964, 6627],
            [7825, 6603],
            [7774, 6559],
            [7682, 6436],
            [7568, 6354],
            [7422, 6360],
            [7357, 6400],
            [7295, 6498],
            [7188, 6558],
            [7140, 6632],
            [7142, 6672],
            [7207, 6780],
            [7195, 6860],
            [7279, 6920],
            [7293, 7101],
            [7343, 7158],
            [7555, 7235],
            [7611, 7278],
            [7638, 7341],
            [7636, 7495],
            [7715, 7619],
            [7805, 7733],
            [7757, 7828],
            [7666, 7842],
            [7723, 7985],
            [7705, 8117],
            [7742, 8425],
            [7721, 8561],
            [7819, 8656],
            [7879, 8767],
            [7871, 8823],
            [7782, 8902],
            [7765, 8960],
            [7783, 9137],
            [7860, 9125],
            [7915, 9200],
            [7937, 9289],
            [8082, 9364],
            [8210, 9494],
            [8185, 9519],
            [8272, 9526],
            [8351, 9568],
            [8529, 9579],
            [8561, 9662],
            [8644, 9734],
            [8865, 9729],
            [9288, 9164],
            [9400, 8679],
            [9405, 8533],
            [9439, 8509],
            [9625, 8508],
            [9708, 8482],
            [9740, 8408],
            [9802, 8352],
            [9851, 8342],
            [9795, 8216],
            [9814, 8112],
            [9787, 7989],
            [9749, 7929],
            [9818, 7849],
            [9796, 7726],
            [9664, 7645],
            [9594, 7618],
            [9515, 7542],
            [9413, 7482],
            [9247, 7513],
            [9150, 7411],
            [9104, 7321],
            [9046, 7272],
            [9043, 7204],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.AK',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.38,
        'hc-middle-y': 0.61,
        'hc-key': 'ng-ak',
        'hc-a2': 'AK',
        labelrank: '3',
        hasc: 'NG.AK',
        'alt-name': null,
        'woe-id': '2346349',
        subregion: null,
        fips: 'NI21',
        'postal-code': 'AK',
        name: 'Akwa Ibom',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.90963',
        'woe-name': 'Akwa Ibom',
        latitude: '4.89926',
        'woe-label': 'Akwa Ibom, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3389, 1580],
            [3359, 1730],
            [3409, 1793],
            [3426, 1972],
            [3416, 2025],
            [3530, 2047],
            [3504, 2088],
            [3528, 2150],
            [3522, 2212],
            [3581, 2224],
            [3657, 2145],
            [3756, 2079],
            [3730, 2050],
            [3774, 1980],
            [3851, 1983],
            [3907, 1941],
            [3900, 1829],
            [3970, 1687],
            [4077, 1575],
            [4123, 1548],
            [4176, 1405],
            [4105, 1333],
            [3879, 1344],
            [3596, 1301],
            [3446, 1314],
            [3421, 1410],
            [3419, 1417],
            [3423, 1476],
            [3416, 1532],
            [3389, 1580],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.AB',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.56,
        'hc-middle-y': 0.3,
        'hc-key': 'ng-ab',
        'hc-a2': 'AB',
        labelrank: '3',
        hasc: 'NG.AB',
        'alt-name': null,
        'woe-id': '2346362',
        subregion: null,
        fips: 'NI45',
        'postal-code': 'AB',
        name: 'Abia',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.56019',
        'woe-name': 'Abia',
        latitude: '5.57402',
        'woe-label': 'Abia, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3756, 2079],
            [3657, 2145],
            [3581, 2224],
            [3522, 2212],
            [3528, 2150],
            [3504, 2088],
            [3530, 2047],
            [3416, 2025],
            [3426, 1972],
            [3409, 1793],
            [3359, 1730],
            [3389, 1580],
            [3328, 1621],
            [3245, 1636],
            [3134, 1620],
            [3097, 1632],
            [3085, 1703],
            [3179, 1847],
            [3166, 1924],
            [3233, 2116],
            [3307, 2242],
            [3286, 2358],
            [3303, 2412],
            [3292, 2514],
            [3166, 2591],
            [3209, 2645],
            [3270, 2677],
            [3365, 2678],
            [3425, 2633],
            [3418, 2522],
            [3472, 2494],
            [3605, 2493],
            [3654, 2470],
            [3675, 2410],
            [3739, 2375],
            [3766, 2187],
            [3811, 2103],
            [3756, 2079],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.IM',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.5,
        'hc-key': 'ng-im',
        'hc-a2': 'IM',
        labelrank: '3',
        hasc: 'NG.IM',
        'alt-name': null,
        'woe-id': '2346356',
        subregion: null,
        fips: 'NI28',
        'postal-code': 'IM',
        name: 'Imo',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.01557',
        'woe-name': 'Imo',
        latitude: '5.55004',
        'woe-label': 'Imo, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3166, 2591],
            [3292, 2514],
            [3303, 2412],
            [3286, 2358],
            [3307, 2242],
            [3233, 2116],
            [3166, 1924],
            [2946, 1916],
            [2817, 1926],
            [2684, 2026],
            [2704, 2152],
            [2667, 2192],
            [2595, 2206],
            [2635, 2381],
            [2696, 2430],
            [2767, 2449],
            [2842, 2442],
            [2891, 2554],
            [3008, 2589],
            [3091, 2571],
            [3166, 2591],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.BY',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.64,
        'hc-key': 'ng-by',
        'hc-a2': 'BY',
        labelrank: '3',
        hasc: 'NG.BY',
        'alt-name': null,
        'woe-id': '20070152',
        subregion: null,
        fips: 'NI52',
        'postal-code': 'BY',
        name: 'Bayelsa',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.97421',
        'woe-name': 'Bayelsa',
        latitude: '4.73907',
        'woe-label': 'Bayelsa, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2681, 1376],
            [2662, 1331],
            [2655, 1222],
            [2637, 1322],
            [2624, 1248],
            [2655, 1153],
            [2585, 1138],
            [2565, 1276],
            [2540, 1142],
            [2495, 1131],
            [2417, 1154],
            [2399, 1131],
            [2267, 1104],
            [2245, 1130],
            [2324, 1235],
            [2230, 1191],
            [2192, 1094],
            [2107, 1091],
            [2115, 1179],
            [2059, 1217],
            [2075, 1107],
            [2016, 1129],
            [2003, 1218],
            [1970, 1144],
            [1820, 1255],
            [1649, 1420],
            [1628, 1505],
            [1588, 1530],
            [1540, 1613],
            [1464, 1878],
            [1528, 1874],
            [1693, 1778],
            [1745, 1776],
            [1810, 1815],
            [1932, 1848],
            [1974, 1896],
            [2043, 1849],
            [2109, 1889],
            [2150, 1886],
            [2219, 1926],
            [2214, 1980],
            [2286, 1990],
            [2342, 2062],
            [2460, 2079],
            [2473, 2107],
            [2558, 2099],
            [2589, 2059],
            [2470, 1933],
            [2417, 1808],
            [2431, 1729],
            [2374, 1620],
            [2373, 1583],
            [2421, 1547],
            [2433, 1491],
            [2537, 1522],
            [2594, 1486],
            [2615, 1423],
            [2681, 1376],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.BE',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.64,
        'hc-middle-y': 0.47,
        'hc-key': 'ng-be',
        'hc-a2': 'BE',
        labelrank: '3',
        hasc: 'NG.BE',
        'alt-name': null,
        'woe-id': '2346354',
        subregion: null,
        fips: 'NI26',
        'postal-code': 'BE',
        name: 'Benue',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '8.70736',
        'woe-name': 'Benue',
        latitude: '7.48719',
        'woe-label': 'Benue, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5350, 3134],
            [5312, 3128],
            [5263, 3062],
            [5208, 3039],
            [5164, 3116],
            [5055, 3243],
            [4974, 3284],
            [4831, 3257],
            [4737, 3276],
            [4723, 3378],
            [4613, 3442],
            [4485, 3470],
            [4427, 3448],
            [4407, 3358],
            [4338, 3332],
            [4226, 3337],
            [4117, 3273],
            [4078, 3362],
            [3994, 3350],
            [3960, 3305],
            [3850, 3292],
            [3827, 3185],
            [3786, 3131],
            [3724, 3169],
            [3694, 3232],
            [3725, 3317],
            [3716, 3405],
            [3655, 3460],
            [3595, 3431],
            [3524, 3444],
            [3435, 3528],
            [3391, 3638],
            [3494, 3575],
            [3535, 3660],
            [3656, 3725],
            [3694, 3788],
            [3713, 3890],
            [3742, 3948],
            [3655, 3976],
            [3630, 4120],
            [3633, 4226],
            [3611, 4291],
            [3558, 4358],
            [3549, 4504],
            [3824, 4448],
            [4119, 4349],
            [4232, 4275],
            [4238, 4322],
            [4174, 4481],
            [4189, 4545],
            [4240, 4588],
            [4359, 4602],
            [4609, 4527],
            [4742, 4531],
            [4915, 4403],
            [4865, 4328],
            [4876, 4308],
            [5002, 4349],
            [5142, 4353],
            [5281, 4338],
            [5384, 4267],
            [5466, 4166],
            [5559, 4083],
            [5600, 3978],
            [5564, 3868],
            [5558, 3761],
            [5473, 3691],
            [5408, 3592],
            [5379, 3433],
            [5372, 3222],
            [5350, 3134],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.CR',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.44,
        'hc-middle-y': 0.43,
        'hc-key': 'ng-cr',
        'hc-a2': 'CR',
        labelrank: '3',
        hasc: 'NG.CR',
        'alt-name': null,
        'woe-id': '2346350',
        subregion: null,
        fips: 'NI22',
        'postal-code': 'CR',
        name: 'Cross River',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '8.67873',
        'woe-name': 'Cross River',
        latitude: '5.93762',
        'woe-label': 'Cross River, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4123, 1548],
            [4077, 1575],
            [3970, 1687],
            [3900, 1829],
            [3907, 1941],
            [3851, 1983],
            [3774, 1980],
            [3730, 2050],
            [3756, 2079],
            [3811, 2103],
            [3766, 2187],
            [3739, 2375],
            [3777, 2454],
            [3775, 2497],
            [3820, 2559],
            [3827, 2651],
            [3898, 2653],
            [3916, 2612],
            [3999, 2648],
            [4025, 2686],
            [4075, 2674],
            [4108, 2766],
            [4197, 2872],
            [4194, 2991],
            [4251, 3023],
            [4215, 3129],
            [4130, 3223],
            [4117, 3273],
            [4226, 3337],
            [4338, 3332],
            [4407, 3358],
            [4427, 3448],
            [4485, 3470],
            [4613, 3442],
            [4723, 3378],
            [4737, 3276],
            [4831, 3257],
            [4974, 3284],
            [5055, 3243],
            [5164, 3116],
            [5208, 3039],
            [5148, 2967],
            [5061, 2930],
            [5012, 2843],
            [4887, 2742],
            [4753, 2600],
            [4747, 2563],
            [4692, 2570],
            [4632, 2518],
            [4637, 2432],
            [4598, 2387],
            [4666, 2313],
            [4672, 2266],
            [4627, 2214],
            [4626, 2140],
            [4595, 2059],
            [4604, 2015],
            [4580, 1891],
            [4543, 1869],
            [4497, 1780],
            [4400, 1638],
            [4409, 1593],
            [4370, 1585],
            [4324, 1476],
            [4289, 1520],
            [4224, 1517],
            [4224, 1576],
            [4177, 1561],
            [4132, 1629],
            [4060, 1686],
            [4123, 1548],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.TA',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.62,
        'hc-middle-y': 0.56,
        'hc-key': 'ng-ta',
        'hc-a2': 'TA',
        labelrank: '3',
        hasc: 'NG.TA',
        'alt-name': null,
        'woe-id': '2346371',
        subregion: null,
        fips: 'NI43',
        'postal-code': 'TA',
        name: 'Taraba',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '10.5428',
        'woe-name': 'Taraba',
        latitude: '7.93608',
        'woe-label': 'Taraba, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [5350, 3134],
            [5372, 3222],
            [5379, 3433],
            [5408, 3592],
            [5473, 3691],
            [5558, 3761],
            [5564, 3868],
            [5600, 3978],
            [5559, 4083],
            [5466, 4166],
            [5384, 4267],
            [5281, 4338],
            [5142, 4353],
            [5002, 4349],
            [4876, 4308],
            [4865, 4328],
            [4915, 4403],
            [5097, 4534],
            [5085, 4637],
            [5037, 4698],
            [5065, 4770],
            [5258, 4739],
            [5319, 4802],
            [5437, 4804],
            [5503, 4822],
            [5614, 4921],
            [5738, 5000],
            [5875, 5165],
            [6085, 5217],
            [6228, 5288],
            [6259, 5347],
            [6251, 5493],
            [6202, 5632],
            [6198, 5758],
            [6172, 5850],
            [6220, 5881],
            [6335, 5886],
            [6446, 5938],
            [6506, 5949],
            [6631, 5935],
            [6728, 5928],
            [7046, 5943],
            [7131, 5787],
            [7214, 5753],
            [7267, 5706],
            [7325, 5586],
            [7321, 5522],
            [7353, 5469],
            [7449, 5396],
            [7455, 5333],
            [7366, 5144],
            [7356, 5017],
            [7296, 4966],
            [7063, 4683],
            [6955, 4571],
            [6946, 4543],
            [6987, 4446],
            [7049, 4355],
            [7078, 4353],
            [7140, 4426],
            [7201, 4425],
            [7313, 4316],
            [7357, 4211],
            [7370, 4089],
            [7405, 3994],
            [7254, 3819],
            [7294, 3799],
            [7387, 3673],
            [7321, 3645],
            [7260, 3577],
            [7212, 3567],
            [7097, 3465],
            [7076, 3417],
            [7107, 3365],
            [7051, 3224],
            [6966, 3186],
            [6942, 3097],
            [6878, 3063],
            [6715, 3056],
            [6675, 3073],
            [6641, 3186],
            [6637, 3302],
            [6588, 3363],
            [6503, 3378],
            [6473, 3406],
            [6431, 3524],
            [6222, 3626],
            [6200, 3692],
            [6163, 3529],
            [6125, 3458],
            [5891, 3454],
            [5837, 3494],
            [5823, 3561],
            [5782, 3566],
            [5559, 3377],
            [5464, 3364],
            [5394, 3143],
            [5350, 3134],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KW',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.64,
        'hc-middle-y': 0.69,
        'hc-key': 'ng-kw',
        'hc-a2': 'KW',
        labelrank: '3',
        hasc: 'NG.KW',
        'alt-name': null,
        'woe-id': '2346358',
        subregion: null,
        fips: 'NI30',
        'postal-code': 'KW',
        name: 'Kwara',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '4.46906',
        'woe-name': 'Kwara',
        latitude: '8.804449999999999',
        'woe-label': 'Kwara, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-926, 5000],
            [-940, 5225],
            [-913, 5261],
            [-914, 5347],
            [-894, 5485],
            [-812, 5479],
            [-785, 5500],
            [-699, 5485],
            [-637, 5500],
            [-600, 5544],
            [-543, 5691],
            [-562, 5821],
            [-540, 5874],
            [-455, 5961],
            [-453, 6006],
            [-404, 6006],
            [-368, 6045],
            [-386, 6141],
            [-363, 6169],
            [-261, 6204],
            [-207, 6197],
            [-127, 6308],
            [-114, 6400],
            [-66, 6453],
            [19, 6467],
            [164, 6470],
            [251, 6439],
            [551, 6076],
            [610, 6055],
            [624, 5993],
            [612, 5852],
            [641, 5801],
            [787, 5796],
            [796, 5707],
            [902, 5660],
            [910, 5563],
            [952, 5536],
            [1116, 5590],
            [1257, 5519],
            [1312, 5420],
            [1423, 5394],
            [1484, 5397],
            [1545, 5355],
            [1621, 5338],
            [1722, 5241],
            [1809, 5229],
            [1849, 5169],
            [1972, 5161],
            [2123, 5179],
            [2185, 5142],
            [2235, 5152],
            [2196, 5103],
            [2143, 4882],
            [2116, 4834],
            [1860, 4858],
            [1679, 4914],
            [1598, 4974],
            [1452, 4809],
            [1472, 4727],
            [1546, 4646],
            [1607, 4608],
            [1613, 4553],
            [1516, 4551],
            [1463, 4518],
            [1447, 4468],
            [1334, 4470],
            [1274, 4508],
            [1217, 4491],
            [1183, 4521],
            [1118, 4518],
            [1072, 4568],
            [839, 4524],
            [721, 4529],
            [679, 4560],
            [621, 4700],
            [544, 4783],
            [515, 4906],
            [483, 4955],
            [404, 5134],
            [405, 5245],
            [525, 5371],
            [510, 5407],
            [465, 5380],
            [374, 5396],
            [266, 5435],
            [192, 5487],
            [146, 5561],
            [61, 5577],
            [20, 5548],
            [-13, 5444],
            [-52, 5411],
            [-240, 5319],
            [-358, 5242],
            [-466, 5195],
            [-556, 5216],
            [-764, 5059],
            [-872, 5045],
            [-926, 5000],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.LA',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.71,
        'hc-middle-y': 0.48,
        'hc-key': 'ng-la',
        'hc-a2': 'LA',
        labelrank: '7',
        hasc: 'NG.LA',
        'alt-name': null,
        'woe-id': '2346342',
        subregion: null,
        fips: 'NI05',
        'postal-code': 'LA',
        name: 'Lagos',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '3.52478',
        'woe-name': 'Lagos',
        latitude: '6.43313',
        'woe-label': 'Lagos, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [512, 3010],
            [315, 3048],
            [81, 3070],
            [-309, 3054],
            [-363, 3086],
            [-219, 3094],
            [-192, 3144],
            [-34, 3177],
            [-16, 3211],
            [71, 3226],
            [-5, 3245],
            [-106, 3198],
            [-243, 3160],
            [-276, 3174],
            [-273, 3229],
            [-346, 3184],
            [-377, 3091],
            [-364, 3043],
            [-519, 3044],
            [-640, 3031],
            [-782, 3040],
            [-987, 3023],
            [-979, 3120],
            [-865, 3112],
            [-813, 3165],
            [-614, 3154],
            [-560, 3161],
            [-488, 3314],
            [-459, 3325],
            [-376, 3269],
            [-325, 3270],
            [-303, 3307],
            [231, 3305],
            [286, 3290],
            [245, 3226],
            [281, 3171],
            [337, 3203],
            [393, 3200],
            [394, 3161],
            [342, 3111],
            [416, 3069],
            [515, 3062],
            [512, 3010],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.NI',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.47,
        'hc-key': 'ng-ni',
        'hc-a2': 'NI',
        labelrank: '3',
        hasc: 'NG.NI',
        'alt-name': null,
        'woe-id': '2346359',
        subregion: null,
        fips: 'NI31',
        'postal-code': 'NI',
        name: 'Niger',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.45494',
        'woe-name': 'Niger',
        latitude: '9.95553',
        'woe-label': 'Niger, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-15, 7360],
            [75, 7356],
            [255, 7256],
            [549, 7253],
            [643, 7266],
            [734, 7240],
            [843, 7167],
            [901, 7149],
            [868, 6913],
            [836, 6862],
            [730, 6804],
            [695, 6746],
            [705, 6612],
            [748, 6572],
            [727, 6439],
            [810, 6415],
            [832, 6507],
            [970, 6539],
            [1027, 6567],
            [1050, 6627],
            [981, 6745],
            [977, 6876],
            [993, 6937],
            [1084, 6937],
            [1234, 7002],
            [1178, 7109],
            [1222, 7163],
            [1202, 7263],
            [1158, 7295],
            [1062, 7314],
            [941, 7386],
            [956, 7443],
            [1081, 7497],
            [1348, 7548],
            [1413, 7545],
            [1466, 7512],
            [1478, 7444],
            [1552, 7336],
            [1547, 7230],
            [1582, 7190],
            [1732, 7199],
            [1889, 7264],
            [1951, 7274],
            [2020, 7342],
            [2080, 7326],
            [2186, 7159],
            [2199, 7098],
            [2155, 7047],
            [2165, 6901],
            [2135, 6752],
            [2207, 6640],
            [2238, 6644],
            [2328, 6751],
            [2436, 6832],
            [2500, 6846],
            [2564, 6796],
            [2630, 6826],
            [2699, 6826],
            [2715, 6877],
            [2805, 6875],
            [2818, 6784],
            [2864, 6789],
            [2914, 6746],
            [2922, 6621],
            [3013, 6579],
            [2989, 6519],
            [2854, 6403],
            [2894, 6350],
            [2959, 6322],
            [3160, 6316],
            [3203, 6285],
            [3218, 6106],
            [3147, 6069],
            [3217, 6019],
            [3256, 5928],
            [3147, 5774],
            [3192, 5718],
            [3185, 5663],
            [3230, 5665],
            [3102, 5484],
            [3054, 5507],
            [2969, 5589],
            [2915, 5607],
            [2747, 5601],
            [2721, 5565],
            [2727, 4914],
            [2754, 4859],
            [2795, 4854],
            [2723, 4772],
            [2664, 4673],
            [2556, 4807],
            [2460, 4879],
            [2375, 5106],
            [2291, 5158],
            [2235, 5152],
            [2185, 5142],
            [2123, 5179],
            [1972, 5161],
            [1849, 5169],
            [1809, 5229],
            [1722, 5241],
            [1621, 5338],
            [1545, 5355],
            [1484, 5397],
            [1423, 5394],
            [1312, 5420],
            [1257, 5519],
            [1116, 5590],
            [952, 5536],
            [910, 5563],
            [902, 5660],
            [796, 5707],
            [787, 5796],
            [641, 5801],
            [612, 5852],
            [624, 5993],
            [610, 6055],
            [551, 6076],
            [251, 6439],
            [164, 6470],
            [19, 6467],
            [-66, 6453],
            [-65, 6484],
            [-147, 6598],
            [-73, 6734],
            [22, 6705],
            [97, 6882],
            [86, 6976],
            [50, 6990],
            [4, 7089],
            [26, 7164],
            [-15, 7360],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.FC',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.36,
        'hc-middle-y': 0.56,
        'hc-key': 'ng-fc',
        'hc-a2': 'FC',
        labelrank: '3',
        hasc: 'NG.FC',
        'alt-name': 'Abuja',
        'woe-id': '2346345',
        subregion: null,
        fips: 'NI11',
        'postal-code': 'FC',
        name: 'Federal Capital Territory',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.18889',
        'woe-name': 'Federal Capital Territory',
        latitude: '8.78852',
        'woe-label': 'Abuja Capital Territory, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2795, 4854],
            [2754, 4859],
            [2727, 4914],
            [2721, 5565],
            [2747, 5601],
            [2915, 5607],
            [2969, 5589],
            [3054, 5507],
            [3102, 5484],
            [3230, 5665],
            [3316, 5674],
            [3389, 5659],
            [3438, 5713],
            [3515, 5676],
            [3476, 5600],
            [3455, 5503],
            [3456, 5357],
            [3413, 5173],
            [3373, 5064],
            [3302, 4969],
            [3185, 4912],
            [3056, 4878],
            [2925, 4858],
            [2885, 4852],
            [2795, 4854],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.OG',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.39,
        'hc-middle-y': 0.56,
        'hc-key': 'ng-og',
        'hc-a2': 'OG',
        labelrank: '3',
        hasc: 'NG.OG',
        'alt-name': null,
        'woe-id': '2346346',
        subregion: null,
        fips: 'NI16',
        'postal-code': 'OG',
        name: 'Ogun',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '3.29255',
        'woe-name': 'Ogun',
        latitude: '7.01845',
        'woe-label': 'Ogun, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [650, 2964],
            [570, 2999],
            [512, 3010],
            [515, 3062],
            [416, 3069],
            [342, 3111],
            [394, 3161],
            [393, 3200],
            [337, 3203],
            [281, 3171],
            [245, 3226],
            [286, 3290],
            [231, 3305],
            [-303, 3307],
            [-325, 3270],
            [-376, 3269],
            [-459, 3325],
            [-488, 3314],
            [-560, 3161],
            [-614, 3154],
            [-813, 3165],
            [-865, 3112],
            [-979, 3120],
            [-955, 3196],
            [-959, 3273],
            [-915, 3325],
            [-918, 3367],
            [-965, 3418],
            [-952, 3476],
            [-970, 3583],
            [-914, 3629],
            [-950, 3695],
            [-925, 3749],
            [-942, 3975],
            [-903, 3985],
            [-894, 4038],
            [-958, 4139],
            [-950, 4328],
            [-999, 4420],
            [-913, 4478],
            [-825, 4474],
            [-802, 4431],
            [-799, 4328],
            [-758, 4274],
            [-735, 4361],
            [-700, 4361],
            [-696, 4281],
            [-731, 4188],
            [-713, 4121],
            [-645, 4051],
            [-605, 3975],
            [-542, 3916],
            [-441, 3900],
            [-404, 3931],
            [-366, 4022],
            [-328, 4047],
            [-253, 3961],
            [-198, 3987],
            [-107, 3984],
            [-76, 3939],
            [-75, 3872],
            [-22, 3838],
            [2, 3722],
            [-58, 3634],
            [110, 3644],
            [276, 3691],
            [341, 3721],
            [367, 3641],
            [481, 3668],
            [537, 3568],
            [703, 3591],
            [717, 3573],
            [695, 3454],
            [549, 3324],
            [526, 3236],
            [551, 3203],
            [642, 3189],
            [720, 3245],
            [744, 3113],
            [670, 3052],
            [626, 3042],
            [719, 3002],
            [706, 2960],
            [650, 2964],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.ON',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.31,
        'hc-middle-y': 0.46,
        'hc-key': 'ng-on',
        'hc-a2': 'ON',
        labelrank: '3',
        hasc: 'NG.ON',
        'alt-name': null,
        'woe-id': '2346347',
        subregion: null,
        fips: 'NI48',
        'postal-code': 'ON',
        name: 'Ondo',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.19165',
        'woe-name': 'Ondo',
        latitude: '7.1444',
        'woe-label': 'Ondo, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1113, 2535],
            [1007, 2674],
            [953, 2707],
            [854, 2819],
            [650, 2964],
            [706, 2960],
            [719, 3002],
            [626, 3042],
            [670, 3052],
            [744, 3113],
            [720, 3245],
            [642, 3189],
            [551, 3203],
            [526, 3236],
            [549, 3324],
            [695, 3454],
            [717, 3573],
            [752, 3591],
            [799, 3676],
            [874, 3716],
            [965, 3666],
            [999, 3671],
            [1003, 3805],
            [1027, 3891],
            [1112, 3923],
            [1113, 3960],
            [1177, 3980],
            [1376, 3976],
            [1422, 3962],
            [1462, 3854],
            [1514, 3834],
            [1610, 3914],
            [1661, 4029],
            [1690, 4142],
            [1798, 4242],
            [1862, 4266],
            [1935, 4278],
            [2002, 4160],
            [2058, 4098],
            [1972, 4024],
            [1990, 3975],
            [1988, 3848],
            [1918, 3784],
            [1872, 3645],
            [1835, 3604],
            [1837, 3501],
            [1804, 3465],
            [1785, 3384],
            [1742, 3338],
            [1675, 3358],
            [1609, 3319],
            [1586, 3379],
            [1610, 3428],
            [1569, 3461],
            [1313, 3463],
            [1188, 3292],
            [1181, 3221],
            [1225, 3136],
            [1168, 3016],
            [1125, 2998],
            [1094, 2927],
            [1161, 2854],
            [1201, 2838],
            [1217, 2783],
            [1114, 2536],
            [1113, 2535],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.EK',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.45,
        'hc-middle-y': 0.44,
        'hc-key': 'ng-ek',
        'hc-a2': 'EK',
        labelrank: '7',
        hasc: 'NG.EK',
        'alt-name': null,
        'woe-id': '20070151',
        subregion: null,
        fips: 'NI51',
        'postal-code': 'EK',
        name: 'Ekiti',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.35929',
        'woe-name': 'Ekiti',
        latitude: '7.67104',
        'woe-label': 'Ekiti, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1183, 4521],
            [1217, 4491],
            [1274, 4508],
            [1334, 4470],
            [1447, 4468],
            [1463, 4518],
            [1516, 4551],
            [1613, 4553],
            [1596, 4490],
            [1704, 4508],
            [1733, 4475],
            [1686, 4431],
            [1692, 4353],
            [1722, 4326],
            [1862, 4266],
            [1798, 4242],
            [1690, 4142],
            [1661, 4029],
            [1610, 3914],
            [1514, 3834],
            [1462, 3854],
            [1422, 3962],
            [1376, 3976],
            [1177, 3980],
            [1113, 3960],
            [1042, 4154],
            [1056, 4351],
            [1162, 4447],
            [1183, 4521],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.OS',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.52,
        'hc-middle-y': 0.51,
        'hc-key': 'ng-os',
        'hc-a2': 'OS',
        labelrank: '3',
        hasc: 'NG.OS',
        'alt-name': null,
        'woe-id': '2346370',
        subregion: null,
        fips: 'NI42',
        'postal-code': 'OS',
        name: 'Osun',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '4.54911',
        'woe-name': 'Osun',
        latitude: '7.47613',
        'woe-label': 'Osun, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1183, 4521],
            [1162, 4447],
            [1056, 4351],
            [1042, 4154],
            [1113, 3960],
            [1112, 3923],
            [1027, 3891],
            [1003, 3805],
            [999, 3671],
            [965, 3666],
            [874, 3716],
            [799, 3676],
            [752, 3591],
            [717, 3573],
            [703, 3591],
            [537, 3568],
            [481, 3668],
            [367, 3641],
            [341, 3721],
            [276, 3691],
            [342, 4021],
            [285, 4123],
            [241, 4160],
            [291, 4363],
            [353, 4346],
            [454, 4458],
            [507, 4424],
            [540, 4370],
            [577, 4362],
            [725, 4466],
            [721, 4529],
            [839, 4524],
            [1072, 4568],
            [1118, 4518],
            [1183, 4521],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.OY',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.47,
        'hc-key': 'ng-oy',
        'hc-a2': 'OY',
        labelrank: '3',
        hasc: 'NG.OY',
        'alt-name': null,
        'woe-id': '2346360',
        subregion: null,
        fips: 'NI32',
        'postal-code': 'OY',
        name: 'Oyo',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '3.61681',
        'woe-name': 'Oyo',
        latitude: '8.189690000000001',
        'woe-label': 'Oyo, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [721, 4529],
            [725, 4466],
            [577, 4362],
            [540, 4370],
            [507, 4424],
            [454, 4458],
            [353, 4346],
            [291, 4363],
            [241, 4160],
            [285, 4123],
            [342, 4021],
            [276, 3691],
            [110, 3644],
            [-58, 3634],
            [2, 3722],
            [-22, 3838],
            [-75, 3872],
            [-76, 3939],
            [-107, 3984],
            [-198, 3987],
            [-253, 3961],
            [-328, 4047],
            [-366, 4022],
            [-404, 3931],
            [-441, 3900],
            [-542, 3916],
            [-605, 3975],
            [-645, 4051],
            [-713, 4121],
            [-731, 4188],
            [-696, 4281],
            [-700, 4361],
            [-735, 4361],
            [-758, 4274],
            [-799, 4328],
            [-802, 4431],
            [-825, 4474],
            [-913, 4478],
            [-999, 4420],
            [-984, 4457],
            [-962, 4644],
            [-937, 4711],
            [-970, 4811],
            [-963, 4900],
            [-926, 5000],
            [-872, 5045],
            [-764, 5059],
            [-556, 5216],
            [-466, 5195],
            [-358, 5242],
            [-240, 5319],
            [-52, 5411],
            [-13, 5444],
            [20, 5548],
            [61, 5577],
            [146, 5561],
            [192, 5487],
            [266, 5435],
            [374, 5396],
            [465, 5380],
            [510, 5407],
            [525, 5371],
            [405, 5245],
            [404, 5134],
            [483, 4955],
            [515, 4906],
            [544, 4783],
            [621, 4700],
            [679, 4560],
            [721, 4529],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.AN',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.48,
        'hc-middle-y': 0.5,
        'hc-key': 'ng-an',
        'hc-a2': 'AN',
        labelrank: '3',
        hasc: 'NG.AN',
        'alt-name': null,
        'woe-id': '2346353',
        subregion: null,
        fips: 'NI25',
        'postal-code': 'AN',
        name: 'Anambra',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '6.98472',
        'woe-name': 'Anambra',
        latitude: '6.30827',
        'woe-label': 'Anambra, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3270, 2677],
            [3209, 2645],
            [3166, 2591],
            [3091, 2571],
            [3008, 2589],
            [2891, 2554],
            [2842, 2442],
            [2767, 2449],
            [2696, 2430],
            [2635, 2381],
            [2605, 2384],
            [2577, 2408],
            [2596, 2495],
            [2650, 2574],
            [2668, 2729],
            [2707, 2753],
            [2720, 2812],
            [2698, 2873],
            [2648, 3092],
            [2645, 3148],
            [2720, 3147],
            [2750, 3177],
            [2792, 3309],
            [2854, 3367],
            [2861, 3312],
            [2922, 3308],
            [3031, 3268],
            [3027, 3206],
            [2976, 3152],
            [2959, 3061],
            [3017, 3041],
            [3072, 2932],
            [3055, 2876],
            [3089, 2878],
            [3180, 2697],
            [3270, 2677],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.BA',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.72,
        'hc-key': 'ng-ba',
        'hc-a2': 'BA',
        labelrank: '7',
        hasc: 'NG.BA',
        'alt-name': null,
        'woe-id': '2346343',
        subregion: null,
        fips: 'NI46',
        'postal-code': 'BA',
        name: 'Bauchi',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '9.88584',
        'woe-name': 'Bauchi',
        latitude: '10.4101',
        'woe-label': 'Bauchi, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6631, 5935],
            [6506, 5949],
            [6446, 5938],
            [6335, 5886],
            [6220, 5881],
            [6172, 5850],
            [5992, 5954],
            [5548, 6157],
            [5494, 6121],
            [5542, 6040],
            [5533, 6010],
            [5451, 5967],
            [5425, 5911],
            [5357, 5890],
            [5214, 5882],
            [5030, 5923],
            [4958, 6025],
            [4903, 6057],
            [4942, 6163],
            [4919, 6300],
            [4861, 6321],
            [4756, 6302],
            [4723, 6325],
            [4724, 6470],
            [4701, 6565],
            [4669, 6605],
            [4564, 6609],
            [4484, 6690],
            [4524, 6804],
            [4591, 6909],
            [4585, 6972],
            [4518, 7090],
            [4521, 7235],
            [4548, 7292],
            [4634, 7310],
            [4785, 7485],
            [4874, 7497],
            [4959, 7528],
            [5014, 7527],
            [5124, 7489],
            [5237, 7494],
            [5318, 7434],
            [5486, 7456],
            [5546, 7365],
            [5539, 7247],
            [5560, 7197],
            [5612, 7176],
            [5754, 7187],
            [5820, 7158],
            [5853, 7269],
            [5952, 7308],
            [6009, 7382],
            [5723, 7432],
            [5657, 7458],
            [5533, 7637],
            [5488, 7632],
            [5474, 7687],
            [5503, 7742],
            [5488, 7839],
            [5443, 7876],
            [5356, 7856],
            [5318, 7882],
            [5336, 7950],
            [5384, 7993],
            [5460, 8000],
            [5519, 8033],
            [5792, 8139],
            [5804, 8237],
            [5889, 8499],
            [6004, 8542],
            [6079, 8513],
            [6197, 8592],
            [6310, 8502],
            [6343, 8327],
            [6380, 8263],
            [6387, 8160],
            [6416, 8014],
            [6526, 7749],
            [6532, 7672],
            [6502, 7531],
            [6570, 7493],
            [6516, 7436],
            [6432, 7386],
            [6360, 7304],
            [6265, 7260],
            [6194, 7050],
            [6145, 6958],
            [6242, 6918],
            [6281, 6783],
            [6404, 6717],
            [6423, 6663],
            [6423, 6482],
            [6321, 6429],
            [6354, 6346],
            [6541, 6209],
            [6569, 6150],
            [6591, 6034],
            [6631, 5935],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.GO',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.46,
        'hc-key': 'ng-go',
        'hc-a2': 'GO',
        labelrank: '3',
        hasc: 'NG.GO',
        'alt-name': null,
        'woe-id': '20070155',
        subregion: null,
        fips: 'NI55',
        'postal-code': 'GO',
        name: 'Gombe',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '11.2421',
        'woe-name': 'Gombe',
        latitude: '10.4342',
        'woe-label': 'Gombe, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7046, 5943],
            [6728, 5928],
            [6631, 5935],
            [6591, 6034],
            [6569, 6150],
            [6541, 6209],
            [6354, 6346],
            [6321, 6429],
            [6423, 6482],
            [6423, 6663],
            [6404, 6717],
            [6281, 6783],
            [6242, 6918],
            [6145, 6958],
            [6194, 7050],
            [6265, 7260],
            [6360, 7304],
            [6432, 7386],
            [6516, 7436],
            [6570, 7493],
            [6694, 7527],
            [6819, 7468],
            [6877, 7424],
            [7067, 7219],
            [7092, 7164],
            [7083, 6954],
            [7098, 6862],
            [7195, 6860],
            [7207, 6780],
            [7142, 6672],
            [7140, 6632],
            [7188, 6558],
            [7295, 6498],
            [7357, 6400],
            [7422, 6360],
            [7419, 6160],
            [7372, 6094],
            [7205, 5992],
            [7129, 5958],
            [7046, 5943],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.DE',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.45,
        'hc-middle-y': 0.67,
        'hc-key': 'ng-de',
        'hc-a2': 'DE',
        labelrank: '3',
        hasc: 'NG.DE',
        'alt-name': null,
        'woe-id': '2346364',
        subregion: null,
        fips: 'NI36',
        'postal-code': 'DE',
        name: 'Delta',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.88195',
        'woe-name': 'Delta',
        latitude: '5.44265',
        'woe-label': 'Delta, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2577, 2408],
            [2527, 2217],
            [2458, 2147],
            [2473, 2107],
            [2460, 2079],
            [2342, 2062],
            [2286, 1990],
            [2214, 1980],
            [2219, 1926],
            [2150, 1886],
            [2109, 1889],
            [2043, 1849],
            [1974, 1896],
            [1932, 1848],
            [1810, 1815],
            [1745, 1776],
            [1693, 1778],
            [1528, 1874],
            [1529, 1920],
            [1440, 1909],
            [1419, 2067],
            [1523, 2089],
            [1536, 2063],
            [1592, 2105],
            [1636, 2100],
            [1599, 2145],
            [1603, 2218],
            [1552, 2128],
            [1505, 2114],
            [1349, 2152],
            [1290, 2211],
            [1281, 2250],
            [1319, 2285],
            [1468, 2264],
            [1500, 2320],
            [1575, 2301],
            [1501, 2351],
            [1456, 2298],
            [1407, 2306],
            [1413, 2414],
            [1365, 2317],
            [1273, 2285],
            [1227, 2327],
            [1191, 2401],
            [1195, 2461],
            [1244, 2467],
            [1280, 2522],
            [1355, 2549],
            [1376, 2584],
            [1220, 2506],
            [1151, 2455],
            [1113, 2535],
            [1114, 2536],
            [1217, 2783],
            [1281, 2752],
            [1324, 2701],
            [1322, 2594],
            [1356, 2586],
            [1409, 2631],
            [1414, 2684],
            [1535, 2682],
            [1596, 2648],
            [1661, 2699],
            [1718, 2700],
            [1824, 2642],
            [1929, 2552],
            [1906, 2487],
            [1922, 2431],
            [2044, 2445],
            [2217, 2604],
            [2228, 2674],
            [2144, 2739],
            [2074, 2903],
            [2112, 2981],
            [2184, 2924],
            [2248, 2971],
            [2525, 3110],
            [2590, 3105],
            [2645, 3148],
            [2648, 3092],
            [2698, 2873],
            [2720, 2812],
            [2707, 2753],
            [2668, 2729],
            [2650, 2574],
            [2596, 2495],
            [2577, 2408],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.ED',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.57,
        'hc-middle-y': 0.54,
        'hc-key': 'ng-ed',
        'hc-a2': 'ED',
        labelrank: '3',
        hasc: 'NG.ED',
        'alt-name': null,
        'woe-id': '2346365',
        subregion: null,
        fips: 'NI37',
        'postal-code': 'ED',
        name: 'Edo',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '5.84934',
        'woe-name': 'Edo',
        latitude: '6.52416',
        'woe-label': 'Edo, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1217, 2783],
            [1201, 2838],
            [1161, 2854],
            [1094, 2927],
            [1125, 2998],
            [1168, 3016],
            [1225, 3136],
            [1181, 3221],
            [1188, 3292],
            [1313, 3463],
            [1569, 3461],
            [1610, 3428],
            [1586, 3379],
            [1609, 3319],
            [1675, 3358],
            [1742, 3338],
            [1785, 3384],
            [1804, 3465],
            [1837, 3501],
            [1835, 3604],
            [1872, 3645],
            [1918, 3784],
            [1988, 3848],
            [1990, 3975],
            [1972, 4024],
            [2058, 4098],
            [2133, 4055],
            [2152, 3963],
            [2272, 3996],
            [2351, 3919],
            [2425, 3923],
            [2496, 3801],
            [2603, 3827],
            [2666, 3773],
            [2686, 3708],
            [2656, 3531],
            [2621, 3430],
            [2621, 3265],
            [2645, 3148],
            [2590, 3105],
            [2525, 3110],
            [2248, 2971],
            [2184, 2924],
            [2112, 2981],
            [2074, 2903],
            [2144, 2739],
            [2228, 2674],
            [2217, 2604],
            [2044, 2445],
            [1922, 2431],
            [1906, 2487],
            [1929, 2552],
            [1824, 2642],
            [1718, 2700],
            [1661, 2699],
            [1596, 2648],
            [1535, 2682],
            [1414, 2684],
            [1409, 2631],
            [1356, 2586],
            [1322, 2594],
            [1324, 2701],
            [1281, 2752],
            [1217, 2783],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.EN',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.55,
        'hc-middle-y': 0.48,
        'hc-key': 'ng-en',
        'hc-a2': 'EN',
        labelrank: '7',
        hasc: 'NG.EN',
        'alt-name': null,
        'woe-id': '2346366',
        subregion: null,
        fips: 'NI47',
        'postal-code': 'EN',
        name: 'Enugu',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.38408',
        'woe-name': 'Enugu',
        latitude: '6.55396',
        'woe-label': 'Enugu, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3391, 3638],
            [3435, 3528],
            [3524, 3444],
            [3595, 3431],
            [3655, 3460],
            [3716, 3405],
            [3725, 3317],
            [3694, 3232],
            [3574, 3211],
            [3609, 3094],
            [3608, 3029],
            [3569, 2908],
            [3607, 2750],
            [3566, 2698],
            [3571, 2605],
            [3546, 2592],
            [3470, 2648],
            [3425, 2633],
            [3365, 2678],
            [3270, 2677],
            [3180, 2697],
            [3089, 2878],
            [3055, 2876],
            [3072, 2932],
            [3017, 3041],
            [2959, 3061],
            [2976, 3152],
            [3027, 3206],
            [3031, 3268],
            [2922, 3308],
            [2861, 3312],
            [2854, 3367],
            [2909, 3435],
            [2959, 3369],
            [3034, 3441],
            [3156, 3536],
            [3208, 3603],
            [3316, 3668],
            [3391, 3638],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.EB',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.59,
        'hc-middle-y': 0.42,
        'hc-key': 'ng-eb',
        'hc-a2': 'EB',
        labelrank: '3',
        hasc: 'NG.EB',
        'alt-name': null,
        'woe-id': '20070153',
        subregion: null,
        fips: 'NI53',
        'postal-code': 'EB',
        name: 'Ebonyi',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.98254',
        'woe-name': 'Ebonyi',
        latitude: '6.32648',
        'woe-label': null,
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4117, 3273],
            [4130, 3223],
            [4215, 3129],
            [4251, 3023],
            [4194, 2991],
            [4197, 2872],
            [4108, 2766],
            [4075, 2674],
            [4025, 2686],
            [3999, 2648],
            [3916, 2612],
            [3898, 2653],
            [3827, 2651],
            [3820, 2559],
            [3775, 2497],
            [3777, 2454],
            [3739, 2375],
            [3675, 2410],
            [3654, 2470],
            [3605, 2493],
            [3472, 2494],
            [3418, 2522],
            [3425, 2633],
            [3470, 2648],
            [3546, 2592],
            [3571, 2605],
            [3566, 2698],
            [3607, 2750],
            [3569, 2908],
            [3608, 3029],
            [3609, 3094],
            [3574, 3211],
            [3694, 3232],
            [3724, 3169],
            [3786, 3131],
            [3827, 3185],
            [3850, 3292],
            [3960, 3305],
            [3994, 3350],
            [4078, 3362],
            [4117, 3273],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KD',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.54,
        'hc-middle-y': 0.35,
        'hc-key': 'ng-kd',
        'hc-a2': 'KD',
        labelrank: '7',
        hasc: 'NG.KD',
        'alt-name': null,
        'woe-id': '2346351',
        subregion: null,
        fips: 'NI23',
        'postal-code': 'KD',
        name: 'Kaduna',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '7.43906',
        'woe-name': 'Kaduna',
        latitude: '10.3294',
        'woe-label': 'Kaduna, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4524, 6804],
            [4484, 6690],
            [4564, 6609],
            [4552, 6552],
            [4451, 6458],
            [4435, 6390],
            [4458, 6321],
            [4423, 6201],
            [4426, 6065],
            [4360, 5963],
            [4360, 5833],
            [4474, 5686],
            [4452, 5578],
            [4366, 5434],
            [4292, 5391],
            [4204, 5498],
            [4093, 5531],
            [4016, 5436],
            [3944, 5397],
            [3911, 5591],
            [3847, 5636],
            [3810, 5708],
            [3754, 5699],
            [3688, 5621],
            [3515, 5676],
            [3438, 5713],
            [3389, 5659],
            [3316, 5674],
            [3230, 5665],
            [3185, 5663],
            [3192, 5718],
            [3147, 5774],
            [3256, 5928],
            [3217, 6019],
            [3147, 6069],
            [3218, 6106],
            [3203, 6285],
            [3160, 6316],
            [2959, 6322],
            [2894, 6350],
            [2854, 6403],
            [2989, 6519],
            [3013, 6579],
            [2922, 6621],
            [2914, 6746],
            [2864, 6789],
            [2818, 6784],
            [2805, 6875],
            [2715, 6877],
            [2699, 6826],
            [2630, 6826],
            [2564, 6796],
            [2500, 6846],
            [2436, 6832],
            [2328, 6751],
            [2238, 6644],
            [2207, 6640],
            [2135, 6752],
            [2165, 6901],
            [2155, 7047],
            [2199, 7098],
            [2254, 7123],
            [2259, 7159],
            [2364, 7258],
            [2482, 7230],
            [2657, 7280],
            [2708, 7336],
            [2754, 7469],
            [2851, 7553],
            [2962, 7525],
            [2988, 7473],
            [2950, 7410],
            [3048, 7373],
            [3124, 7320],
            [3176, 7359],
            [3175, 7458],
            [3300, 7458],
            [3321, 7520],
            [3377, 7553],
            [3443, 7540],
            [3551, 7466],
            [3624, 7496],
            [3656, 7543],
            [3718, 7548],
            [3823, 7627],
            [3950, 7667],
            [3982, 7652],
            [3960, 7555],
            [4007, 7506],
            [4070, 7483],
            [4122, 7430],
            [4253, 7388],
            [4345, 7290],
            [4363, 7163],
            [4345, 7093],
            [4359, 6984],
            [4289, 6915],
            [4339, 6874],
            [4411, 6865],
            [4451, 6818],
            [4524, 6804],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KO',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.72,
        'hc-middle-y': 0.6,
        'hc-key': 'ng-ko',
        'hc-a2': 'KO',
        labelrank: '3',
        hasc: 'NG.KO',
        'alt-name': null,
        'woe-id': '2346369',
        subregion: null,
        fips: 'NI41',
        'postal-code': 'KO',
        name: 'Kogi',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '6.6142',
        'woe-name': 'Kogi',
        latitude: '7.78485',
        'woe-label': 'Kogi, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3391, 3638],
            [3316, 3668],
            [3208, 3603],
            [3156, 3536],
            [3034, 3441],
            [2959, 3369],
            [2909, 3435],
            [2854, 3367],
            [2792, 3309],
            [2750, 3177],
            [2720, 3147],
            [2645, 3148],
            [2621, 3265],
            [2621, 3430],
            [2656, 3531],
            [2686, 3708],
            [2666, 3773],
            [2603, 3827],
            [2496, 3801],
            [2425, 3923],
            [2351, 3919],
            [2272, 3996],
            [2152, 3963],
            [2133, 4055],
            [2058, 4098],
            [2002, 4160],
            [1935, 4278],
            [1862, 4266],
            [1722, 4326],
            [1692, 4353],
            [1686, 4431],
            [1733, 4475],
            [1704, 4508],
            [1596, 4490],
            [1613, 4553],
            [1607, 4608],
            [1546, 4646],
            [1472, 4727],
            [1452, 4809],
            [1598, 4974],
            [1679, 4914],
            [1860, 4858],
            [2116, 4834],
            [2143, 4882],
            [2196, 5103],
            [2235, 5152],
            [2291, 5158],
            [2375, 5106],
            [2460, 4879],
            [2556, 4807],
            [2664, 4673],
            [2723, 4772],
            [2795, 4854],
            [2885, 4852],
            [2925, 4858],
            [2895, 4768],
            [2938, 4691],
            [2927, 4497],
            [2887, 4368],
            [3020, 4446],
            [3204, 4507],
            [3394, 4496],
            [3549, 4504],
            [3558, 4358],
            [3611, 4291],
            [3633, 4226],
            [3630, 4120],
            [3655, 3976],
            [3742, 3948],
            [3713, 3890],
            [3694, 3788],
            [3656, 3725],
            [3535, 3660],
            [3494, 3575],
            [3391, 3638],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.PL',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.53,
        'hc-middle-y': 0.64,
        'hc-key': 'ng-pl',
        'hc-a2': 'PL',
        labelrank: '3',
        hasc: 'NG.PL',
        'alt-name': null,
        'woe-id': '2346348',
        subregion: null,
        fips: 'NI49',
        'postal-code': 'PL',
        name: 'Plateau',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '9.60601',
        'woe-name': 'Plateau',
        latitude: '8.95327',
        'woe-label': 'Plateau, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6172, 5850],
            [6198, 5758],
            [6202, 5632],
            [6251, 5493],
            [6259, 5347],
            [6228, 5288],
            [6085, 5217],
            [5875, 5165],
            [5738, 5000],
            [5614, 4921],
            [5503, 4822],
            [5437, 4804],
            [5319, 4802],
            [5286, 4849],
            [5131, 4925],
            [5074, 4926],
            [4933, 4894],
            [4848, 4895],
            [4717, 4949],
            [4695, 5069],
            [4656, 5143],
            [4716, 5242],
            [4749, 5253],
            [4808, 5325],
            [4826, 5383],
            [4785, 5420],
            [4727, 5403],
            [4606, 5414],
            [4563, 5458],
            [4548, 5520],
            [4452, 5578],
            [4474, 5686],
            [4360, 5833],
            [4360, 5963],
            [4426, 6065],
            [4423, 6201],
            [4458, 6321],
            [4435, 6390],
            [4451, 6458],
            [4552, 6552],
            [4564, 6609],
            [4669, 6605],
            [4701, 6565],
            [4724, 6470],
            [4723, 6325],
            [4756, 6302],
            [4861, 6321],
            [4919, 6300],
            [4942, 6163],
            [4903, 6057],
            [4958, 6025],
            [5030, 5923],
            [5214, 5882],
            [5357, 5890],
            [5425, 5911],
            [5451, 5967],
            [5533, 6010],
            [5542, 6040],
            [5494, 6121],
            [5548, 6157],
            [5992, 5954],
            [6172, 5850],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.NA',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.49,
        'hc-middle-y': 0.48,
        'hc-key': 'ng-na',
        'hc-a2': 'NA',
        labelrank: '3',
        hasc: 'NG.NA',
        'alt-name': null,
        'woe-id': '20070154',
        subregion: null,
        fips: 'NI56',
        'postal-code': 'NA',
        name: 'Nasarawa',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '8.27694',
        'woe-name': 'Nasarawa',
        latitude: '8.50412',
        'woe-label': 'Nasarawa, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4452, 5578],
            [4548, 5520],
            [4563, 5458],
            [4606, 5414],
            [4727, 5403],
            [4785, 5420],
            [4826, 5383],
            [4808, 5325],
            [4749, 5253],
            [4716, 5242],
            [4656, 5143],
            [4695, 5069],
            [4717, 4949],
            [4848, 4895],
            [4933, 4894],
            [5074, 4926],
            [5131, 4925],
            [5286, 4849],
            [5319, 4802],
            [5258, 4739],
            [5065, 4770],
            [5037, 4698],
            [5085, 4637],
            [5097, 4534],
            [4915, 4403],
            [4742, 4531],
            [4609, 4527],
            [4359, 4602],
            [4240, 4588],
            [4189, 4545],
            [4174, 4481],
            [4238, 4322],
            [4232, 4275],
            [4119, 4349],
            [3824, 4448],
            [3549, 4504],
            [3394, 4496],
            [3204, 4507],
            [3020, 4446],
            [2887, 4368],
            [2927, 4497],
            [2938, 4691],
            [2895, 4768],
            [2925, 4858],
            [3056, 4878],
            [3185, 4912],
            [3302, 4969],
            [3373, 5064],
            [3413, 5173],
            [3456, 5357],
            [3455, 5503],
            [3476, 5600],
            [3515, 5676],
            [3688, 5621],
            [3754, 5699],
            [3810, 5708],
            [3847, 5636],
            [3911, 5591],
            [3944, 5397],
            [4016, 5436],
            [4093, 5531],
            [4204, 5498],
            [4292, 5391],
            [4366, 5434],
            [4452, 5578],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.JI',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.54,
        'hc-middle-y': 0.28,
        'hc-key': 'ng-ji',
        'hc-a2': 'JI',
        labelrank: '3',
        hasc: 'NG.JI',
        'alt-name': null,
        'woe-id': '2346367',
        subregion: null,
        fips: 'NI39',
        'postal-code': 'JI',
        name: 'Jigawa',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '9.36225',
        'woe-name': 'Jigawa',
        latitude: '12.0714',
        'woe-label': 'Jigawa, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6197, 8592],
            [6079, 8513],
            [6004, 8542],
            [5889, 8499],
            [5804, 8237],
            [5792, 8139],
            [5519, 8033],
            [5460, 8000],
            [5384, 7993],
            [5336, 7950],
            [5318, 7882],
            [5356, 7856],
            [5443, 7876],
            [5488, 7839],
            [5503, 7742],
            [5474, 7687],
            [5488, 7632],
            [5533, 7637],
            [5657, 7458],
            [5723, 7432],
            [6009, 7382],
            [5952, 7308],
            [5853, 7269],
            [5820, 7158],
            [5754, 7187],
            [5612, 7176],
            [5560, 7197],
            [5539, 7247],
            [5546, 7365],
            [5486, 7456],
            [5318, 7434],
            [5237, 7494],
            [5124, 7489],
            [5014, 7527],
            [4959, 7528],
            [4984, 7629],
            [5072, 7722],
            [5019, 7751],
            [4960, 7848],
            [4872, 7868],
            [4917, 7971],
            [4942, 8075],
            [4918, 8155],
            [4789, 8138],
            [4782, 8183],
            [4716, 8173],
            [4687, 8203],
            [4708, 8245],
            [4707, 8329],
            [4669, 8376],
            [4562, 8399],
            [4545, 8483],
            [4477, 8527],
            [4466, 8618],
            [4334, 8651],
            [4236, 8617],
            [4183, 8514],
            [4112, 8646],
            [4082, 8694],
            [4011, 8696],
            [3964, 8725],
            [3982, 8869],
            [4078, 8883],
            [4339, 8883],
            [4396, 8779],
            [4511, 8748],
            [4595, 8756],
            [4678, 8811],
            [4734, 8896],
            [4995, 8866],
            [5092, 8881],
            [5282, 8859],
            [5334, 8886],
            [5443, 8852],
            [5521, 8886],
            [5545, 8934],
            [5623, 8972],
            [5791, 9029],
            [5851, 8982],
            [5884, 8868],
            [5982, 8880],
            [6107, 8857],
            [6160, 8780],
            [6197, 8592],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      id: 'NG.KN',
      properties: {
        'hc-group': 'admin1',
        'hc-middle-x': 0.5,
        'hc-middle-y': 0.38,
        'hc-key': 'ng-kn',
        'hc-a2': 'KN',
        labelrank: '7',
        hasc: 'NG.KN',
        'alt-name': null,
        'woe-id': '2346357',
        subregion: null,
        fips: 'NI29',
        'postal-code': 'KN',
        name: 'Kano',
        country: 'Nigeria',
        'type-en': 'State',
        region: null,
        longitude: '8.541460000000001',
        'woe-name': 'Kano',
        latitude: '11.7323',
        'woe-label': 'Kano, NG, Nigeria',
        type: 'State',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [4524, 6804],
            [4451, 6818],
            [4411, 6865],
            [4339, 6874],
            [4289, 6915],
            [4359, 6984],
            [4345, 7093],
            [4363, 7163],
            [4345, 7290],
            [4253, 7388],
            [4122, 7430],
            [4070, 7483],
            [4007, 7506],
            [3960, 7555],
            [3982, 7652],
            [3950, 7667],
            [3823, 7627],
            [3718, 7548],
            [3656, 7543],
            [3594, 7596],
            [3580, 7642],
            [3601, 7730],
            [3630, 7764],
            [3762, 7809],
            [3725, 7927],
            [3708, 8049],
            [3716, 8370],
            [3785, 8417],
            [3943, 8476],
            [3976, 8507],
            [4027, 8633],
            [4112, 8646],
            [4183, 8514],
            [4236, 8617],
            [4334, 8651],
            [4466, 8618],
            [4477, 8527],
            [4545, 8483],
            [4562, 8399],
            [4669, 8376],
            [4707, 8329],
            [4708, 8245],
            [4687, 8203],
            [4716, 8173],
            [4782, 8183],
            [4789, 8138],
            [4918, 8155],
            [4942, 8075],
            [4917, 7971],
            [4872, 7868],
            [4960, 7848],
            [5019, 7751],
            [5072, 7722],
            [4984, 7629],
            [4959, 7528],
            [4874, 7497],
            [4785, 7485],
            [4634, 7310],
            [4548, 7292],
            [4521, 7235],
            [4518, 7090],
            [4585, 6972],
            [4591, 6909],
            [4524, 6804],
          ],
        ],
      },
    },
  ],
};
